export default "__VITE_ASSET__Cq9_5WJp__"